import { useState, useEffect } from 'react';
import useDataBean from '../../../core/services/dataBean/useDataBean';
import { _RemoteAbstractAction } from '../../../core/services/dataBean/EntityCatalog';




interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}

export const ProjectSelectVdos = ({ idSelector, onChange, label }: Props) => {

    const { lista, setLista, instance } = useDataBean(_RemoteAbstractAction);
    // const [lista, setLista] = useState<any>([])
    const [id, setID] = useState(0);

    useEffect(() => {
        if (idSelector >= 0) {
            setID(idSelector);
        }
    }, [])

    useEffect(() => {
        getLista();
    }, [])


    useEffect(() => {
        onChange(id);
    }, [id])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(id);
    }


    const getLista = () => {

        instance.getProjectCatalogPorPropiedadesRender({ State: 1 }).then(
            (resp: any) => {
                //console.log(resp);

                setLista(resp);
            }
        )

    }

    return (
        <>
            <label>{label ?? "Proyecto:"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option>...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.IDProject} >{item.DataBeanProperties.Name}</option>
                        )
                    })
                }
            </select>
        </>
    )
}